module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"al":{"contact":"Kontakt","helpMessage":"Ju duhet ndihmë? Na kontaktoni."},"en":{"contact":"Contact","helpMessage":"Need help? Contact us."}}')
  delete Component.options._Ctor
}
